/**
 * Zweck: Initialisiert die reguläre Angular-Webanwendung und registriert den Service Worker.
 */
import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import 'zone.js';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

declare let window: any;
const {version: appVersion} = require('../package.json');

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    if ('serviceWorker' in navigator && environment.production) {
      navigator.serviceWorker.register('/ngsw-worker.js');
    }
  })
  .catch(err => console.log(err));
